import styled from 'styled-components';
import { fromLarge, fromMedium, toLarge } from 'styleUtils/mediaQueries';
import { gridDisplay, gridTemplateRows, gridTemplateColumns } from 'styleUtils/grid';
import { GridItem } from './GridItem';

const gridBiggerColumn = '55%';
const gridSmallerColumn = '40%';
const gridOverlapColumn = '5%';

const rightGridColumnLayout = `${gridBiggerColumn} ${gridOverlapColumn} ${gridSmallerColumn}`;
const leftGridColumnLayout = `${gridSmallerColumn} ${gridOverlapColumn} ${gridBiggerColumn}`;

const hasImageGridRowLayout = `75px 300px 300px 75px`;
const offsetMeetGridRowLayout = `100px 200px 200px 100px 100px`;
const defaultGridRowLayout = `75px 200px 200px 75px`;

export const Wrapper = styled.div<GridItem>`
    ${gridDisplay()}
    ${gridTemplateColumns('100%')}
    ${gridTemplateRows('auto')}

    ${toLarge`
        margin-bottom: 1.5rem;
    `};

    ${fromMedium`
        ${({ meetRight }): string => {
            return gridTemplateColumns(meetRight ? '60% 40%' : '40% 60%');
        }};
    `};

    ${fromLarge`
        ${({ meetRight }): string => {
            return gridTemplateColumns(meetRight ? rightGridColumnLayout : leftGridColumnLayout);
        }};
        
        ${({ hasImage, offsetMeet }): string => {
            if (hasImage) {
                return gridTemplateRows(hasImageGridRowLayout);
            }

            if (offsetMeet) {
                return gridTemplateRows(offsetMeetGridRowLayout);
            }

            return gridTemplateRows(defaultGridRowLayout);
        }}
  `};
`;
